import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setFormDetail } from "../../../../../redux/slice/form";
import { useHookForm } from "../../../../../components/hooks";

import { FormRadio } from "../../../../../components/formElement";
import { option_control_correct } from "../../../../../service/option";

import ImgQuestion from "../../../../../images/other/question_icon.PNG";

import { Button } from "primereact/button";

export default function ModuleControlStep4(props) {
  const { onTabChange } = props;
  const dispatch = useDispatch();
  const redux_form = useSelector((state) => state.form);
  // 表單欄位預設值
  const defaultValues = {
    c1: null,
    c2: null,
    c3: null,
    c4: null,
    c5: null,
    c6: null,
  };
  const { handleSubmit, reset, yup, setSchema, setting } = useHookForm({
    defaultValues,
  });

  useEffect(() => {
    setSchema(
      yup
        .object({
          c1: yup.number().required("必填").nullable(),
          c2: yup.number().required("必填").nullable(),
          c3: yup.number().required("必填").nullable(),
          c4: yup.number().required("必填").nullable(),
          c5: yup.number().required("必填").nullable(),
          c6: yup.number().required("必填").nullable(),
        })
        .required()
    );
  }, []);

  useEffect(() => {
    if (redux_form.formDetail?.step4) {
      reset(redux_form.formDetail.step4);
    }
  }, [redux_form]);

  const onSubmit = (submitData) => {
    let jsonData = {
      ...redux_form.formDetail,
      step4: submitData,
    };
    dispatch(setFormDetail(jsonData));

    onTabChange({ index: 4 });
  };

  return (
    <>
      <form onSubmit={handleSubmit(onSubmit)} className="text-lg">
        <div className="flex align-items-center text-2xl font-bold mb-2">
          <img className="mr-2" src={ImgQuestion} alt="Question" />
          讓我們來確認您對於上面提供的資訊是否已經了解呢？
        </div>

        <div className="mt-2 ml-2">
          {option_control_correct.map((item, index) => (
            <div key={item.value} className="mb-2">
              <div className="flex align-items-start text-lg font-bold">
                <div
                  className="inline-flex align-items-center justify-content-center flex-shrink-0 text-white bg-red-500 border-1 border-500 border-circle mr-2"
                  style={{
                    width: "1.7rem",
                    height: "1.7rem",
                    lineHeight: "1.7rem",
                  }}
                >
                  {index + 1}
                </div>
                <div>{item.label}</div>
              </div>
              <div className="flex flex-wrap pl-5">
                {item.options.map((option) => (
                  <FormRadio
                    key={`q_${option.value}`}
                    setting={setting}
                    data={{
                      name: `c${index + 1}`,
                      label: option.label,
                      value: option.value,
                    }}
                  />
                ))}
              </div>
            </div>
          ))}
        </div>

        <div className="col-12 text-center my-3">
          <Button
            className="p-button-warning text-white px-3 rotate-icon-x-180"
            type="button"
            label="上一步：考量"
            icon="fa fa-reply bg-main border-round-md p-1"
            onClick={() => onTabChange({ index: 2 })}
          />
          <Button
            className="p-button-warning text-white ml-3 px-3 rotate-icon-xy-180 rotate-icon-y-180"
            type="submit"
            label="下一步：決定"
            icon="fa fa-reply bg-main border-round-md p-1"
          />
        </div>
      </form>
    </>
  );
}
